import classNames from './TheButton.module.scss';
import classes from 'classnames';
import { useAppSelector } from '@/store';
import SVG from 'react-inlinesvg';
import { ButtonHTMLAttributes } from 'react';

import rightArrow from '@/assets/svg/right-arrow-large.svg';
import { authSelector, interfaceLanguageSelector } from '@/store/reducers/auth';
import { rtlLangs } from '@/context/LocaleContext';
import { UnitAssets } from '@/types/units';
import UseUnitsAssets from '@/hooks/UseUnitsAssets';
import { unitSelector } from '@/store/reducers/unit';

interface TheButtonProps {
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  text: string;
  description?: string;
  descriptionClassName?: string;
  className?: string;
  plain?: boolean;
  showArrow?: boolean;
  shouldRecolor?: boolean;
  disabled?: boolean;
  allowDynamicDirection?: boolean;
  ariaLabel?: string;
  icon?: string;
  emitOnClick?: () => void;
}

const TheButton = ({
  type = 'button',
  text,
  description,
  descriptionClassName,
  className,
  plain = false,
  showArrow = false,
  shouldRecolor = true,
  disabled = false,
  allowDynamicDirection = true,
  ariaLabel,
  icon,
  emitOnClick,
}: TheButtonProps) => {
  const interfaceLanguage = useAppSelector(interfaceLanguageSelector);
  const { user } = useAppSelector(authSelector);
  const { unitsAssets } = UseUnitsAssets();
  const { selectedUnit } = useAppSelector(unitSelector);
  const unitAssets: UnitAssets = unitsAssets[selectedUnit.order || 1];

  let isRtl;
  if (user?.metadata.languagePreferences.interfaceLanguage) {
    isRtl = rtlLangs.includes(user?.metadata.languagePreferences.interfaceLanguage);
  }

  return (
    <button
      type={type}
      className={classes(
        classNames.theButton,
        {
          [classNames[`theButton-${interfaceLanguage?.direction}`]]: allowDynamicDirection,
        },
        { [classNames.plain]: plain },
        className
      )}
      style={
        !plain && shouldRecolor && !disabled ? { backgroundColor: unitAssets.modalBorderColor } : {}
      }
      onClick={emitOnClick}
      disabled={disabled}
      aria-label={ariaLabel || text}
    >
      {icon && <SVG src={icon} className={classes()} />}
      {description && <span className={descriptionClassName}>{description}</span>}
      <span>{text}</span>
      {showArrow && (
        <SVG
          src={rightArrow}
          className={classes()}
          style={{
            transform: `rotate(${isRtl && allowDynamicDirection ? '180deg' : '0deg'})`,
          }}
        />
      )}
    </button>
  );
};

export default TheButton;
